import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useNavigate } from "react-router-dom";

const Forbidden: React.FC = () => {
  const navigate = useNavigate();
  const accountType = localStorage.getItem('accountType')

  const handlenavigation = () => {
    if(accountType === 'OWNER'){
      navigate("/ott/dashboard")
    }else{
      navigate("/ott/franchise-dashboard")
    }
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
      bgcolor="#0a0a23"
    >
      <Paper
        elevation={6}
        sx={{
          p: 6,
          borderRadius: 4,
          textAlign: "center",
          maxWidth: 480,
          bgcolor: "#1e1e2f",
          color: "white",
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant="h2" color="error" gutterBottom>
          403
        </Typography>
        <Typography variant="h5" gutterBottom>
          Forbidden
        </Typography>
        <Typography variant="body1" sx={{ mb: 4 }}>
          🚫 You don’t have permission to access this page.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          sx={{ borderRadius: 3, px: 4 }}
          //onClick={() => navigate("/ott/dashboard")}
          onClick={handlenavigation}
        >
          Go Back to Dashboard
        </Button>
      </Paper>
    </Box>
  );
};

export default Forbidden;